import { render } from "./model-tr.html?vue&type=template&id=e1d5be06&scoped=true&ts=true"
import script from "./model-tr.ts?vue&type=script&lang=ts"
export * from "./model-tr.ts?vue&type=script&lang=ts"

import "./model-tr.scss?vue&type=style&index=0&id=e1d5be06&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1d5be06"]])

export default __exports__